import React from 'react';
import { Tr, Tbody, Td } from '@chakra-ui/react';
import NoResultsFoundWrapper from '../NoResultsFoundIndicator/NoResultsFoundWrapper';
import { RenderIf } from '../RenderIf/RenderIf';
const ResultTableBody = ({ colCount, children, isFetching = false, mainText, subText, useIcon = true, ...rest }) => {
    const hasResults = Array.isArray(children) ? !!children.length : !!children;
    return (React.createElement(Tbody, { ...rest },
        React.createElement(RenderIf, { condition: !hasResults && !isFetching },
            React.createElement(Tr, { "data-testid": "result_table_body__no_results_found" },
                React.createElement(Td, { colSpan: colCount },
                    React.createElement(NoResultsFoundWrapper, { mainText: mainText, subText: subText, useIcon: useIcon })))),
        React.createElement(RenderIf, { condition: hasResults }, children)));
};
export default ResultTableBody;
